<template>
  <div id="kasi">
    <el-carousel height="250px">
      <el-carousel-item v-for="item in pics" :key="item">
        <el-image fit="fill" :src="item"></el-image>
      </el-carousel-item>
    </el-carousel>
    <el-image id="top_image" style="display: block;" fit="fill" src='/static/images/kasi/content_1.jpg'></el-image>
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 20px;">
      <span style="color: black; font-size: 20px; font-weight: bold;">
              创始人增长战略课
      </span>
      <span style="color: black; font-size: 18px; font-weight: normal; margin-top: 10px;">
              卡思增长咨询
      </span>
      <span style="color: black; font-size: 16px; font-weight: normal; margin-top: 5px;">
              提出并拥有"全域增长理论体系"的新一代咨询公司
      </span>
<!--      <span style="color: #3c3c3c; font-size: 16px; font-weight: normal; margin-top: 15px;">-->
<!--              8月25-27日 中国·上海-->
<!--      </span>-->
    </div>
    <el-form ref="form" :model="form" style="width: 80%; margin-left: 10%; margin-top: 20px; margin-bottom: 20px;">
      <el-form-item>
        <el-input v-model="form.kasi_name" placeholder="您的姓名（已加密）"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.kasi_phone" placeholder="手机号码（已加密）"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.kasi_company" placeholder="公司名称（已加密）"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.kasi_job" placeholder="您的职务（已加密）"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.kasi_gmv" placeholder="年营业额（已加密）"></el-input>
      </el-form-item>
      <el-checkbox v-model="checked" label="已阅读并同意《个人信息与隐私保护条款》" disabled></el-checkbox>
      <el-button type="info" @click="onSubmit" style="width: 100%; background-color: #000000; margin-top: 5px;">立即申请</el-button>
    </el-form>
    <div v-for="item in c_pics" :key="item">
      <el-image style="display: block;" fit="fill" :src="item"></el-image>
    </div>
    <div style="background-color: black">
      <el-button plain @click="onTop" style="display: block; width: 100%; height: 60px;
      background-color: #ffb400; color: black;
      border-color: #ffb400;">立即申请</el-button>
    </div>
    <el-dialog title="操作提示"  width="80%" :visible.sync="dialogVisible" :center="true" :show-close="false">
      <span>{{dialogMsg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import process from "shelljs";
  export default {
    name: 'kasi',
    data() {
      return {
        pics: [
          '/static/images/kasi/head_1.jpg',
          '/static/images/kasi/head_2.jpg',
          '/static/images/kasi/head_3.jpg',
          '/static/images/kasi/head_4.jpg'],
        c_pics: [
          '/static/images/kasi/content_2.jpg',
          '/static/images/kasi/content_3.jpg',
          '/static/images/kasi/content_4.jpg',
          '/static/images/kasi/content_5.jpg'],
        form: {
          kasi_campaign: '中国-上海、北京、广州、杭州等',
          kasi_name: '',
          kasi_phone:'',
          kasi_company:'',
          kasi_job: '',
          kasi_gmv: '',
        },
        checked: true,
        dialogMsg: '',
        dialogVisible: false,
      }
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      onTop(){
        window.scrollTo({
          top: 400,
          behavior: "smooth"
        });
      },
      onSubmit() {
        let base = '/api'
        if (process.env.NODE_ENV === "development") {
          base = 'http://api.wushangxianzhi.com'
        }
        let url = '/api/v2/maoapp/kasi_vue'
        this.$axios({
          method:'post',
          headers: {
            'content-type': 'application/x-www-form-urlencoded', // 注释1
          },
          url: `${base}${url}`,
          data:this.form,
        }).then((response) =>{          //这里使用了ES6的语法
          // alert(response.data.msg)
          this.dialogMsg = response.data.msg
          this.dialogVisible = true
          console.log(response.data)      //请求成功返回的数据
        }).catch((error) => {
          alert(error)
          console.log(error)      //请求失败返回的数据
        })
      }
    },
    metaInfo: {
      title: "卡思咨询",
      meta: [
        { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
        { name: "keywords", content: "卡思咨询" },
        { name: "description", content: "卡思咨询" },
        { name: "format-detection", content: "telephone=no,email=no" }
      ],
      link: [{
        rel: 'shortcut icon',
        href: '/static/kasi_favicon.ico'
      }]
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/kasi/KaSi.vue